export default __webpack_public_path__ + "static/media/maintenance.000aeaf8.PNG";